var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUserPlus = function SvgUserPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02 6.808a3.808 3.808 0 1 1 7.615 0 3.808 3.808 0 0 1-7.616 0ZM3.25 18.577a6.577 6.577 0 0 1 13.154 0v.002l-.001.11a.692.692 0 0 1-.335.582A12.062 12.062 0 0 1 9.827 21c-2.282 0-4.418-.631-6.24-1.73a.692.692 0 0 1-.336-.58l-.001-.113ZM18.48 7.846a.692.692 0 0 0-1.384 0v2.077H15.02a.692.692 0 0 0 0 1.385h2.077v2.077a.692.692 0 1 0 1.385 0v-2.077h2.077a.692.692 0 0 0 0-1.385H18.48V7.846Z",
    fill: "#fff"
  })));
};
export default SvgUserPlus;